import { Component, Input } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import {
  MxMenuType,
  MxTableColumn,
  MxTableOperationItems,
} from 'src/app/shared/domains/common/interfaces';

@Component({ standalone: false,
  selector: '[mx-table-header]',
  templateUrl: './mx.table-header.component.html',
  styleUrls: ['./mx.table-header.component.scss'],
})
export class MxTableHeaderComponent extends MxBaseComponent {
  @Input() columns: MxTableColumn[];
  @Input() columnDefaultWidth: number;
  @Input() operationItems: MxTableOperationItems[];

  operationItemsWidth: number;

  ngOnInit() {
    if (this.operationItems) {
      const speedDialItems = this.operationItems.filter(
        (item) => item.type === MxMenuType.SpeedDial
      );

      const tieredItems = this.operationItems.filter(
        (item) => item.type === MxMenuType.Tiered
      );

      this.operationItemsWidth =
        40 *
        (this.operationItems.filter((item) => item.type === undefined).length +
          (speedDialItems.length !== 0 && tieredItems.length !== 0
            ? 2
            : speedDialItems.length !== 0 || tieredItems.length !== 0
            ? 1
            : 0));
    }
  }
}
